<template>
  <div class="order-detail-wrapper">
    <div class="order-card" :class="{ 'mobile': isMobile }">
      <!-- 手机端专属头部 -->
      <template v-if="isMobile">
        <!-- <div class="mobile-navbar">
          <span class="mobile-back" @click="$router.back()">
            <svg viewBox="0 0 24 24" width="24" height="24"><path d="M15.5 19l-7-7 7-7" stroke="#333" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          <span class="mobile-pay-title">
            <img src="https://img.alicdn.com/imgextra/i4/O1CN01QwQ0kB1w6Qn2ATm8A_!!6000000006292-2-tps-64-64.png" class="alipay-logo" alt="alipay" />
            支付宝付款
          </span>
          <span style="width:24px;"></span>
        </div> -->
      </template>
      <!-- 加载状态 -->
      <div v-if="loading" class="status-container loading">
        <svg class="loading-icon" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke-linecap="round" class="path"></circle>
        </svg>
        <span>正在加载</span>
      </div>
      
      <!-- 错误状态 -->
      <div v-else-if="error" class="status-container error">
        <svg class="error-icon" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
        <span>{{ error }}</span>
      </div>
      
      <!-- 支付成功状态 -->
      <div v-else-if="orderSuccess" class="status-container success">
        <svg class="success-icon" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
        <span>支付成功</span>
      </div>
      
      <!-- 手机端主内容 -->
      <template v-if="isMobile && !loading && !error && !orderSuccess && orderInfo">
        <div class="mobile-main">
          <div class="mobile-product-title">{{ orderInfo.payOrderId }}</div>
          <div class="mobile-amount-main">¥{{ (orderInfo.amount / 100).toFixed(2) }}</div>
          <button class="mobile-pay-btn" @click="handleManualRedirect">点击跳转付款</button>
          <div class="mobile-pay-tip">如未自动跳转，点击上方按钮</div>
        </div>
      </template>
      
      <!-- PC端布局 -->
      <template v-else-if="!loading && !error && !orderSuccess && orderInfo">
        <div class="order-container">
          <div class="order-title">
            <span>支付订单</span>
          </div>
          
          <div class="order-amount">
            <div class="amount-value">¥{{ (orderInfo.amount / 100).toFixed(2) }}</div>
          </div>
          
          <div class="order-id">
            <div class="order-id-label">订单号</div>
            <div class="order-id-value">{{ orderInfo.payOrderId }}</div>
          </div>
          
          <div class="qrcode-section">
            <div class="qrcode-wrapper" :class="{ 'complex-qr': isComplexQR }">
              <img v-if="qrcodeUrl" :src="qrcodeUrl" alt="支付二维码" class="qrcode" />
              <div class="scan-border top-left"></div>
              <div class="scan-border top-right"></div>
              <div class="scan-border bottom-left"></div>
              <div class="scan-border bottom-right"></div>
            </div>
            <div class="scan-tip">
              <span>请使用支付宝扫码支付</span>
            </div>
            <div v-if="isComplexQR" class="complex-tip">
              <span>二维码较复杂，请对准扫描</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getOrderByPayId } from '@/api/api'
import QRCode from 'qrcode'

export default {
  name: 'OrderDetail',
  data() {
    return {
      loading: true,
      error: null,
      orderInfo: null,
      orderSuccess: false,
      isMobile: false,
      qrcodeUrl: '',
      isComplexQR: false
    }
  },
  created() {
    // 检测设备类型
    this.isMobile = this.checkIsMobile()
  },
  mounted() {
    // 获取订单信息
    const payOrderId = this.$route.params.payOrderId
    console.log('订单ID:', payOrderId)
    this.fetchOrderInfo(payOrderId)
    
    // 添加监听刷新事件
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('popstate', this.handleRouteChange)
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('popstate', this.handleRouteChange)
  },
  beforeRouteUpdate(to, from, next) {
    // 路由参数变化时触发重新加载
    if (to.params.payOrderId !== from.params.payOrderId) {
      this.fetchOrderInfo(to.params.payOrderId)
    }
    next()
  },
  methods: {
    // 处理路由变化
    handleRouteChange() {
      const payOrderId = this.$route.params.payOrderId
      if (payOrderId) {
        this.fetchOrderInfo(payOrderId)
      }
    },
    
    // 处理键盘按键
    handleKeyDown(event) {
      // 处理Enter键
      if (event.key === 'Enter') {
        const payOrderId = this.$route.params.payOrderId
        if (payOrderId) {
          this.fetchOrderInfo(payOrderId)
        }
      }
    },
    
    // 检测是否是移动设备
    checkIsMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|Mobile|mini|Fennec|Tablet|Mobi|Palm|Symbian|Phone|Touch/i.test(navigator.userAgent)
    },
    
    // 获取订单信息
    fetchOrderInfo(payOrderId) {
      if (!payOrderId) {
        this.error = '订单ID不存在'
        this.loading = false
        return
      }
      
      this.loading = true
      this.error = null
      this.orderSuccess = false
      this.orderInfo = null // 重置订单信息
      
      getOrderByPayId(payOrderId)
        .then(res => {
          if (!res) {
            this.error = '订单信息为空'
            this.loading = false
            return
          }
          
          this.orderInfo = res
          this.loading = false
          
          // 检查订单状态
          if (this.orderInfo && this.orderInfo.state === 2) { // STATE_SUCCESS
            this.orderSuccess = true
            return
          }
          
          // 如果是移动设备且有支付链接，直接跳转
          if (this.isMobile && this.orderInfo && this.orderInfo.payData) {
            setTimeout(() => {
              window.location.href = this.orderInfo.payData
            }, 500)
          } else if (this.orderInfo && this.orderInfo.payData) {
            // 在PC端生成二维码
            this.$nextTick(() => {
              this.generateQRCode(this.orderInfo.payData)
            })
          }
        })
        .catch(err => {
          console.error('获取订单信息失败:', err)
          this.loading = false
          this.orderInfo = null // 重置订单信息
          
          if (typeof err === 'string') {
            this.error = err
          } else if (err && err.msg) {
            this.error = err.msg
          } else {
            this.error = '获取订单信息失败'
          }
        })
    },
    
    // 生成二维码
    generateQRCode(url) {
      if (!url) return
      
      // 设置QR码的配置
      const qrOptions = {
        width: 400,
        margin: 0,
        errorCorrectionLevel: 'L', // 降低纠错级别，减少二维码复杂度
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }
      
      // 检查URL是否过长
      if (url.length > 180) {
        // 对于长链接使用相同配置但标记为复杂二维码
        QRCode.toDataURL(url, qrOptions)
          .then(dataUrl => {
            this.qrcodeUrl = dataUrl
            this.isComplexQR = true
          })
          .catch(err => {
            console.error('生成二维码失败:', err)
            this.error = '生成二维码失败'
          })
      } else {
        QRCode.toDataURL(url, qrOptions)
          .then(dataUrl => {
            this.qrcodeUrl = dataUrl
            this.isComplexQR = false
          })
          .catch(err => {
            console.error('生成二维码失败:', err)
            this.error = '生成二维码失败'
          })
      }
    },
    
    // 处理手动跳转
    handleManualRedirect() {
      if (this.orderInfo && this.orderInfo.payData) {
        window.location.href = this.orderInfo.payData
      }
    }
  }
}
</script>

<style scoped>
.order-detail-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  /* background-color: #fafafa; */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  padding: 5px;
  box-sizing: border-box;
  overflow: visible;
}

.order-card {
  width: 100%;
  max-width: 360px;
  min-height: auto;
  max-height: none;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  overflow: visible;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 5px 0;
}

/* 状态容器样式 */
.status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 30px 20px;
  text-align: center;
}

.status-container span {
  margin-top: 16px;
  font-size: 16px;
  color: #333;
}

/* 加载状态 */
.loading-icon {
  width: 40px;
  height: 40px;
  animation: loading 1.5s linear infinite;
}

.loading-icon .path {
  stroke: #1890ff;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-linecap: round;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 错误状态 */
.error-icon {
  width: 40px;
  height: 40px;
  fill: #ff4d4f;
}

/* 成功状态 */
.success-icon {
  width: 48px;
  height: 48px;
  fill: #52c41a;
}

/* 订单容器 */
.order-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}

.order-title {
  padding: 5px;
  text-align: center;
  font-size: 15px;
  color: #333;
  background-color: #f9f9f9;
  border-bottom: 1px solid #f0f0f0;
}

.order-amount {
  padding: 6px 12px;
  text-align: center;
  background-color: #ffffff;
  border-bottom: 1px solid #f5f5f5;
}

.amount-value {
  font-size: 18px;
  font-weight: 380;
  color: #333;
}

.order-id {
  padding: 6px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}

.order-id-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 1px;
}

.order-id-value {
  font-size: 13px;
  color: #666;
  word-break: break-all;
}

/* 二维码部分 */
.qrcode-section {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 20px 25px;
}

.qrcode-wrapper {
  position: relative;
  padding: 4px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

/* 为复杂二维码添加特殊样式 */
.complex-qr {
  background-color: white;
  padding: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.qrcode {
  width: 170px;
  height: 170px;
  display: block;
  image-rendering: -webkit-optimize-contrast; /* 提高图像清晰度 */
  image-rendering: crisp-edges; /* 提高边缘清晰度 */
}

.scan-border {
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: #1890ff;
  border-style: solid;
  border-width: 0;
}

.top-left {
  top: 0;
  left: 0;
  border-top-width: 2px;
  border-left-width: 2px;
}

.top-right {
  top: 0;
  right: 0;
  border-top-width: 2px;
  border-right-width: 2px;
}

.bottom-left {
  bottom: 0;
  left: 0;
  border-bottom-width: 2px;
  border-left-width: 2px;
}

.bottom-right {
  bottom: 0;
  right: 0;
  border-bottom-width: 2px;
  border-right-width: 2px;
}

.scan-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 12px;
  margin-bottom: 0;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.alipay-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

/* 移动端样式 */
.order-card.mobile {
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 100%; /* 确保在移动端占满宽度 */
  margin: 0; /* 移除外边距 */
  padding: 0; /* 移除内边距 */
  border-radius: 0; /* 移除圆角 */
  box-shadow: none; /* 移除阴影 */
}

.mobile-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 12px;
}

.mobile-back {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.mobile-pay-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #222;
}

.alipay-logo {
  width: 22px;
  height: 22px;
  margin-right: 6px;
}

.mobile-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2px; /* 最小化左右内边距 */
  background: #fff;
  min-height: calc(100vh - 48px);
  justify-content: center;
  width: 100%; /* 确保内容占满容器宽度 */
}

.mobile-product-title {
  font-size: 18px; /* 增大字体 */
  color: #444;
  margin-bottom: 18px;
  margin-top: 10px;
  width: 95%; /* 让标题占据更多宽度 */
  text-align: center;
  word-break: break-all; /* 允许在任何字符间换行 */
}

.mobile-amount-main {
  font-size: 42px; /* 增大金额字体 */
  font-weight: 700;
  color: #222;
  margin-bottom: 36px;
  width: 95%; /* 让金额占据更多宽度 */
  text-align: center;
}

.mobile-pay-btn {
  width: 95%; /* 调整按钮宽度 */
  max-width: 100%; /* 修改最大宽度为100% */
  background: #1677ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 18px 0;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 18px;
  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.12);
}

.mobile-pay-btn:active {
  background: #0958d9;
}

.mobile-pay-tip {
  color: #888;
  font-size: 14px;
  margin-bottom: 28px;
}

.mobile-download-btn {
  width: 100%;
  max-width: 420px;
  background: none;
  color: #1677ff;
  border: none;
  font-size: 16px;
  padding: 10px 0;
  margin-bottom: 10px;
}

@media (max-width: 480px) {
  .order-detail-wrapper {
    padding: 0; /* 移除包装器的内边距 */
  }
  
  .order-card.mobile {
    min-height: 100vh;
    border-radius: 0;
    box-shadow: none;
    max-width: 100%; /* 确保在小屏幕上占满宽度 */
    margin: 0; /* 确保没有外边距 */
  }
  
  .mobile-main {
    min-height: calc(100vh - 48px);
    padding: 0; /* 完全移除内边距 */
    justify-content: center;
    width: 100%;
  }
  
  .mobile-pay-btn, .mobile-download-btn {
    max-width: 95%;
    width: 95%;
  }
}

/* 添加媒体查询确保在不同高度下显示完整 */
@media screen and (max-height: 640px) {
  .order-title {
    padding: 4px;
    font-size: 14px;
  }
  
  .order-amount {
    padding: 6px;
  }
  
  .amount-value {
    font-size: 18px;
  }
  
  .order-id {
    padding: 4px 16px;
  }
  
  .qrcode {
    width: 150px;
    height: 150px;
  }
  
  .scan-tip {
    font-size: 11px;
    padding: 3px 6px;
  }
  
  .complex-tip {
    font-size: 10px;
    padding: 2px 6px;
    margin-top: 3px;
  }
}

/* 添加额外适配更高分辨率的屏幕 */
@media (min-height: 700px) {
  .qrcode {
    width: 180px;
    height: 180px;
  }
  
  .qrcode-section {
    padding: 20px 20px 30px;
  }
}

.complex-tip {
  margin-top: 5px;
  font-size: 11px;
  color: #ff9800;
  background-color: #fff8e1;
  padding: 3px 8px;
  border-radius: 4px;
  border-left: 2px solid #ff9800;
}
</style>